import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "rt__tail" };
const _hoisted_2 = ["aria-label", "onClick"];
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = { class: "recap-tip__head" };
const _hoisted_5 = { class: "recap-tip__title" };
const _hoisted_6 = {
    key: 0,
    class: "recap-tip__when"
};
const _hoisted_7 = { class: "recap-tip__body" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaRecapText',
    props: {
        lines: {}
    },
    emits: ["follow"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function headOf(text) {
            const cut = text.lastIndexOf(" ");
            return cut < 0 ? "" : text.slice(0, cut + 1);
        }
        function tailOf(text) {
            const cut = text.lastIndexOf(" ");
            return cut < 0 ? text : text.slice(cut + 1);
        }
        return (_ctx, _cache) => {
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lines, (line, index) => {
                return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "rt__sentence"
                }, [
                    _createTextVNode(_toDisplayString(headOf(line.text)), 1),
                    _createElementVNode("span", _hoisted_1, [
                        _createTextVNode(_toDisplayString(tailOf(line.text)), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.sources, (source) => {
                            return (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: source.key,
                                location: "top",
                                "max-width": "320",
                                "open-delay": 200,
                                "content-class": "recap-tip"
                            }, {
                                activator: _withCtx(({ props: tip }) => [
                                    (source.target)
                                        ? (_openBlock(), _createElementBlock("button", _mergeProps({
                                            key: 0,
                                            ref_for: true
                                        }, tip, {
                                            type: "button",
                                            class: "rt__ref rt__ref--link",
                                            "aria-label": `Source ${source.number}: ${source.title}. Open it.`,
                                            onClick: ($event) => (emit('follow', source))
                                        }), _toDisplayString(source.number), 17, _hoisted_2))
                                        : (_openBlock(), _createElementBlock("button", _mergeProps({
                                            key: 1,
                                            ref_for: true
                                        }, tip, {
                                            type: "button",
                                            class: "rt__ref",
                                            "aria-label": `Source ${source.number}: ${source.title}`
                                        }), _toDisplayString(source.number), 17, _hoisted_3))
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(source.title), 1),
                                        (source.when)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(source.when), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(source.body), 1)
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ])
                ]));
            }), 128));
        };
    }
});
